export default function CoverLetterField({ visibleFields, value, onChange, showValidation }) {
  const field = visibleFields.find((f) => f.id === "cover_letter");
  if (!field) return null;
  
  const isMandatory = field.mandatory === true;
  const isEmpty = !value || value.trim() === "";
  const showError = showValidation && isMandatory && isEmpty;
  
  return (
    <div className="flex flex-col">
      <label htmlFor={field.id} className="input-label">
        {field.label} {isMandatory && "*"}
      </label>
      <textarea
        id={field.id}
        name={field.id}
        value={value || ""}
        onChange={onChange}
        className={`input pt-2 h-auto ${showError ? "border-red-500" : ""}`}
        rows={4}
        placeholder={field.label}
      />
    </div>
  );
}


